import { Component, OnInit } from '@angular/core';
import { BzgModalService, BzgModalRef } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { RotationStatus } from '../models/rotation-status';
import { EncryptOperation } from '../models/encrypt-operation';
import { EncryptionService } from '../services/column-encryption.service';

@Component({
  selector: 'biz-column-encryption-key',
  templateUrl: './column-encryption-key.component.html',
  styleUrls: ['./column-encryption-key.component.scss']
})
export class ColumnEncryptionKeyComponent implements OnInit {

  private _rotateAlertComponent: BzgModalRef;
  private _rotateStatus:RotationStatus;
  private _currentOperation: EncryptOperation = EncryptOperation.Rotate;
  public isMasterKeyCrationEnabled: boolean = false;
  public ExistsMasterEncryptionKey: boolean = true;
  constructor(
    private _modalService: BzgModalService,
    private _encryptionService: EncryptionService
  ) {

  }

  ngOnInit(): void {
    this._encryptionService.IsMasterKeyCreationEnabled().then((isEnabled) => {
      this.isMasterKeyCrationEnabled = isEnabled;
    }
    ).catch(() => {
      this.isMasterKeyCrationEnabled = false;
    }
    );
    
    this._encryptionService.ExistsMasterEncryptionKey().then((exists) => {
      this.ExistsMasterEncryptionKey = exists;
    }
    ).catch(() => {
      this.ExistsMasterEncryptionKey = false;
    }
    );
  }
  

  public isInProgressOperation<Boolean>() { return this._rotateStatus === RotationStatus.InProgress };
  public isSucceededOperation<Boolean>() { return this._rotateStatus === RotationStatus.Succeeded };
  public isFailedOperation<Boolean>() { return this._rotateStatus === RotationStatus.Failed };

  public rotateKeys(): void {
    this._currentOperation = EncryptOperation.Rotate;
    this._rotateAlertComponent = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        title: 'ENCRYPTION.TITLE_CONFIRM',
        message: 'ENCRYPTION.CONFIRM_MSG',
        button: 'ENCRYPTION.CONFIRM_BTN_ROTATE'
      } 
    });
    this._rotateAlertComponent.afterClosed().subscribe(async (result) => {
      if (result === 'delete') {//delete is the action name in the modal, but it is actually rotate
        this._rotateStatus = RotationStatus.InProgress;
        this._encryptionService.rotateKeys().then(() => {
          this._rotateStatus = RotationStatus.Succeeded;
        }
        ).catch(() => {
          this._rotateStatus = RotationStatus.Failed;
        }
        );
      }
    });
  }

  public createMasterKey(): void {
    this._currentOperation = EncryptOperation.CreateMasterKey;
    this._rotateStatus = RotationStatus.InProgress;
    this._encryptionService.createMasterKey().then(() => {
      this._rotateStatus = RotationStatus.Succeeded;
    }
    ).catch(() => {
      this._rotateStatus = RotationStatus.Failed;
    }
    );
  }

}
